// extracted by mini-css-extract-plugin
export default {"silver2":"#bdbdbd","item":"zXOJr","itemPreview":"LGwG8","itemId":"NZPow","itemAdditional":"I3CwG"};